import { render, staticRenderFns } from "./EarningHeadr.vue?vue&type=template&id=79a5a226&scoped=true&"
import script from "./EarningHeadr.vue?vue&type=script&lang=js&"
export * from "./EarningHeadr.vue?vue&type=script&lang=js&"
import style0 from "./EarningHeadr.vue?vue&type=style&index=0&id=79a5a226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a5a226",
  null
  
)

export default component.exports